import ar from './ar.json';
import en from './en.json';

export const dictionaryList = { en, ar};

export const languageOptions = {
  en: 'English',
  ar: 'العربية'
};
